<template>
  <BaseTableItemAction
    v-can:[editPermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-pencil"
    actionName="تعديل"
    :to="'/projects/edit/' + this.item.id"
  >
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { WRITE_PROJECTS_PERMISSION } from "@/core/statics/Permissions";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      editPermission: WRITE_PROJECTS_PERMISSION,
    };
  },
};
</script>
